<template>
  <div class="container-pay">
    <div class="page-title">报名缴费</div>
    <div v-if="orderList.length === 0" class="pay-empty">
      <i class="el-icon-s-order" style="font-size: 66px; color: #c0c4cc"></i>
      <div v-if="isCharged" style="margin-top: 20px; color: #909399;">暂无待缴费订单</div>
      <div v-else style="margin-top: 20px; color: #909399;">本考试不收取报名费</div>
    </div>
    <template v-else>
      <el-table :data="orderList" style="width: 100%" v-loading="loading">
        <el-table-column label="订单号" prop="orderNo" min-width="160" show-overflow-tooltip />
        <el-table-column label="考试名称" prop="examName" min-width="160" show-overflow-tooltip />
        <el-table-column label="报考岗位" prop="postName" min-width="120" show-overflow-tooltip />
        <el-table-column label="订单金额(元)" min-width="110">
          <template slot-scope="scope">
            {{ scope.row.orderAmount != null ? (scope.row.orderAmount / 100).toFixed(2) : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="缴费状态" min-width="100">
          <template slot-scope="scope">
            <el-tag :type="payStatusTagType(scope.row.payStatus)">
              {{ payStatusLabel(scope.row.payStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="支付时间" prop="payTime" min-width="160" :formatter="formatTime" />
        <el-table-column label="操作" min-width="100" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="scope.row.payStatus === 0" type="primary" size="mini" :loading="payingId === scope.row.id"
              @click="handlePay(scope.row)">
              去支付
            </el-button>
            <el-button v-else-if="scope.row.payStatus === 1" type="success" size="mini" disabled>
              已支付
            </el-button>
            <el-button v-else type="info" size="mini" disabled>
              已退费
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pay-tip">提示：请确认报名信息无误后点击"去支付"完成缴费。</div>
    </template>

    <!-- 支付二维码弹窗 -->
    <el-dialog title="扫码支付" :visible.sync="qrVisible" width="380px" :close-on-click-modal="false"
      @closed="clearQrcode">
      <div class="qr-content">
        <div class="qr-box">
          <canvas ref="qrCanvas" style="width: 240px; height: 240px;"></canvas>
          <div class="qr-loading" v-if="qrLoading">二维码生成中...</div>
        </div>
        <div class="qr-amount" v-if="payOrder">
          应付金额：<span class="amount">{{ (payOrder.orderAmount || 0) / 100 }}</span> 元
        </div>
        <div class="qr-tip">
          请用微信或支付宝扫码支付，支付完成后请稍候片刻查询缴费状态。
        </div>
        <div class="qr-once-tip">
          <i class="el-icon-warning-outline"></i>
          该二维码仅可扫码一次，请扫码后尽快完成支付
        </div>
      </div>
      <div slot="footer">
        <el-button size="small" @click="qrVisible = false">关闭</el-button>
        <el-button size="small" type="primary" :loading="qrRefreshing" @click="refreshQrcode">刷新二维码</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as ExamOrderApi from "@/api/exam/order";
import QRCode from "qrcode";
import { mapGetters } from "vuex";

export default {
  name: "ExamPay",
  data() {
    return {
      loading: false,
      orderList: [],
      payingId: null,
      qrVisible: false,
      qrLoading: false,
      qrRefreshing: false,
      payOrder: null,
      pollTimer: null,
      pollCount: 0,
    };
  },
  computed: {
    ...mapGetters(["currentExamInfo"]),
    // 考试是否开启收费（chargeFlag === 1 才展示“暂无待缴费订单”，否则提示不收费）
    isCharged() {
      return Number(this.currentExamInfo?.chargeFlag) === 1;
    },
  },
  created() {
    this.getOrderList();
  },
  beforeDestroy() {
    this.stopPolling();
  },
  methods: {
    getOrderList() {
      this.loading = true;
      ExamOrderApi.getOrderList()
        .then((res) => {
          const list = Array.isArray(res) ? res : [];
          // 报名缴费仅显示当前考试的缴费订单
          const examId = this.currentExamInfo?.id;
          this.orderList = examId ? list.filter((o) => o.examId === examId) : list;
        })
        .catch(() => {
          this.orderList = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handlePay(item) {
      // 不再让用户选择支付方式：交行条码聚合码支持微信/支付宝扫码，直接下单并弹二维码
      this.payingId = item.id;
      ExamOrderApi.createPay({ id: item.id })
        .then((res) => {
          this.payingId = null;
          if (res && res.redirectUrl) {
            // 展示二维码供用户扫码支付（微信或支付宝均可）
            this.payOrder = Object.assign({}, item);
            this.qrVisible = true;
            this.$nextTick(() => {
              this.generateQrcode(res.redirectUrl);
            });
            // 扫码后定时轮询交行查询接口，支付成功自动刷新
            this.startPolling(item.id);
          } else {
            this.$message.error("支付地址获取失败，请稍后重试");
          }
        })
        .catch(() => {
          this.payingId = null;
        });
    },
    startPolling(orderId) {
      this.stopPolling();
      this.pollCount = 0;
      this.pollTimer = setInterval(() => {
        this.pollCount += 1;
        ExamOrderApi.queryPay({ id: orderId })
          .then((res) => {
            if (res === true) {
              // 已支付：停止轮询，刷新列表，关闭二维码弹窗
              this.stopPolling();
              this.qrVisible = false;
              this.$message.success("支付成功");
              this.getOrderList();
            } else if (this.pollCount >= 12) {
              // 轮询超时（约 2 分钟）自动停止，用户可手动刷新或点击"刷新二维码"
              this.stopPolling();
            }
          })
          .catch(() => {
            // 单次查询失败忽略，继续轮询
          });
      }, 10000);
    },
    stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
    },
    generateQrcode(url) {
      if (!url) return;
      this.qrLoading = true;
      QRCode.toCanvas(this.$refs.qrCanvas, url, {
        width: 240,
        margin: 1,
        errorCorrectionLevel: "M",
      })
        .then(() => {
          this.qrLoading = false;
        })
        .catch((err) => {
          this.qrLoading = false;
          this.$message.error("二维码生成失败，请重试");
          console.error("[ExamPay][二维码生成失败]", err);
        });
    },
    refreshQrcode() {
      if (!this.payOrder) return;
      this.qrRefreshing = true;
      // 重新下单生成二维码（交行条码聚合码，微信或支付宝均可扫码）
      ExamOrderApi.createPay({ id: this.payOrder.id })
        .then((res) => {
          if (res && res.redirectUrl) {
            this.$nextTick(() => {
              this.generateQrcode(res.redirectUrl);
            });
          } else {
            this.$message.error("刷新二维码失败，请稍后重试");
          }
        })
        .catch(() => {
          this.$message.error("刷新二维码失败，请稍后重试");
        })
        .finally(() => {
          this.qrRefreshing = false;
        });
    },
    clearQrcode() {
      this.stopPolling();
      this.qrLoading = false;
      this.qrRefreshing = false;
      this.payOrder = null;
      this.$nextTick(() => {
        const canvas = this.$refs.qrCanvas;
        if (canvas) {
          const ctx = canvas.getContext("2d");
          ctx.clearRect(0, 0, canvas.width, canvas.height);
        }
      });
    },
    payStatusLabel(status) {
      switch (status) {
        case 0: return "待缴费";
        case 1: return "已缴费";
        case 2: return "已退费";
        default: return "-";
      }
    },
    payStatusTagType(status) {
      switch (status) {
        case 0: return "warning";
        case 1: return "success";
        case 2: return "info";
        default: return "info";
      }
    },
    formatTime(row, column, cellValue) {
      if (!cellValue) return "-";
      const date = new Date(cellValue);
      if (isNaN(date.getTime())) return cellValue;
      const pad = (n) => (n < 10 ? "0" + n : n);
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    },
  },
};
</script>

<style scoped lang="scss">
.container-pay {
  padding: 30px;
  width: 94%;
  box-sizing: border-box;

  .page-title {
    font-size: 20px;
    font-weight: bold;
    color: #A40000;
    margin-bottom: 20px;
  }

  .pay-empty {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    min-height: calc(100vh - 300px);
  }

  .pay-tip {
    margin-top: 16px;
    font-size: 13px;
    color: #909399;
  }

  .qr-content {
    text-align: center;

    .qr-box {
      position: relative;
      display: inline-block;
    }

    .qr-loading {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #909399;
      font-size: 13px;
    }

    .qr-amount {
      margin-top: 16px;
      font-size: 14px;
      color: #606266;

      .amount {
        color: #e6a23c;
        font-size: 20px;
        font-weight: bold;
      }
    }

    .qr-tip {
      margin-top: 10px;
      font-size: 13px;
      color: #909399;
    }

    .qr-once-tip {
      margin-top: 12px;
      font-size: 13px;
      color: #e6a23c;
      background: #fdf6ec;
      border: 1px solid #faecd8;
      border-radius: 6px;
      padding: 8px 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 4px;

      .el-icon-warning-outline {
        font-size: 15px;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .container-pay {
    padding: 20px 12px;
    width: 100%;

    .page-title {
      font-size: 17px;
    }
  }
}
</style>
